<template>
  <div class='progress-chart'>
    <div class='bars'>
      <div class="bar-item" v-for='(bar,i) in chartData.datasets[0].data'>
        <div class="bar-label">
          {{chartData.labels[i]}}
        </div>
        <div class="bar-graph">
          <div class="bar">
            <span class="value" :style='barStyles(i)'></span>
          </div>
          <div class="value">
            {{bar}}%
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    options: {type: Object, default: () => {{}}},
    chartData: {type: Object, default: () => {{}}}
  },
  methods: {
    barStyles (i) {
      const dataset = this.chartData.datasets[0]
      let value = dataset.data[i] > 100 ? 100 : dataset.data[i]
      value = value > 0 ? value : 0
      return `width:${value}%; background-color:${dataset.backgroundColor[i]} `
    }
  }
}
</script>
<style scoped lang='scss'>
  .bar-item {
    margin: 20px 0;
  }
  .bar-label {
    margin-bottom: 0.7em;
  }
  .bar-graph {
    display: flex;
    align-items: center;
    .bar {
      flex: 0 1 92%;
      width: calc(92% - 10px);
      margin-right: 10px;
      background-color: #EDEDED;
      height: 30px;
      span.value {
        display:  inline-block;
        height: 100%;
      }
    }
    .value {
      font-weight: bold;
      //width: 8%;
      flex: 1 0 8%;
      font-size: 150%;
    }
  }
</style>